import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { formatINR } from "@/lib/format";

const POPULAR = ["Necklaces", "Rings", "Pearl", "Diamond", "Bridal"];

export function PopularSearches({ onPick }) {
  return (
    <div>
      <p className="text-luxe text-[10px] text-muted-foreground mb-3">Popular Searches</p>
      <div className="flex flex-wrap gap-2">
        {POPULAR.map((p) => (
          <button
            key={p}
            onClick={() => onPick(p)}
            className="border border-border px-4 py-2 text-xs uppercase tracking-wider text-ink transition-colors hover:border-gold hover:text-gold"
          >
            {p}
          </button>
        ))}
      </div>
    </div>
  );
}

export function SearchResults({ results, term, isFetching, onSelect, onViewAll }) {
  if (results.length === 0) {
    return (
      <p className="py-8 text-center text-sm text-muted-foreground">
        {isFetching ? "Searching…" : `No results for "${term}"`}
      </p>
    );
  }
  return (
    <>
      <ul className="space-y-1">
        {results.map((p) => (
          <li key={p.handle}>
            <Link
              to={`/product/${p.handle}`}
              onClick={onSelect}
              className="flex items-center gap-4 rounded-sm p-2 transition-colors hover:bg-cream"
              data-testid="search-result-item"
            >
              <div className="h-16 w-14 shrink-0 overflow-hidden bg-cream">
                <img src={p.images?.[0]} alt={p.title} className="h-full w-full object-cover" />
              </div>
              <div className="flex-1">
                <p className="text-luxe text-[9px] text-gold">{p.category}</p>
                <p className="font-serif text-base text-ink">{p.title}</p>
                <p className="text-sm text-muted-foreground">{formatINR(p.price)}</p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
      <button
        onClick={onViewAll}
        className="mt-4 flex w-full items-center justify-center gap-2 border-t border-border pt-4 text-xs uppercase tracking-widest text-ink hover:text-gold"
      >
        View all results <ArrowRight size={14} />
      </button>
    </>
  );
}
